import React/*, { useEffect, useState } */ from 'react'
// import api from '../../_services/api'
// import { useParams, useNavigate } from 'react-router-dom'
// import Header from '../../components/HeaderNoMenu'
import { Row, Container/*, Col, Image, Dropdown, DropdownButton */ } from 'react-bootstrap'
// import { padding } from '@mui/system'
import { RechagTV, TextDetails, LabelSelect, Nickname } from './styles'
import { Checkbox } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '../../components/Button'

export default function RechargeTV () {
  // const label = { inputProps: { 'aria-label': 'Salvar para próximas' } };

  return (
      <>
      <Container>
      {/* <Header onClick={() => navigate(-1)} /> */}
      <RechagTV>Recarga de TV</RechagTV>
      <TextDetails>Recarregue sua plataforme de TV, com a grana que você já acumulou.</TextDetails>
      <Row>
      <LabelSelect>Recarga recente</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a recarga recente</option>
        <option value="1">Sky</option>
        <option value="2">Claro TV</option>
        <option value="3">OI TV</option>
      </select>
      </Row>
      <Row>
      <LabelSelect>Código do cliente</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a recarga recente</option>
        <option value="1">Sky</option>
        <option value="2">Claro TV</option>
        <option value="3">OI TV</option>
      </select>
      </Row>
      <Row>
      <LabelSelect>Operadora</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a operadora</option>
        <option value="1">Sky</option>
        <option value="2">Claro TV</option>
        <option value="3">OI TV</option>
      </select>
      </Row>
      <Row>
        <FormControlLabel control={<Checkbox defaultChecked />} label="Salvar para próximas recargas." />
      </Row>
      <Row>
          <Nickname type={Text} value="Apelido" />
      </Row>
      <Row>
          <Button>CONTINUAR</Button>
      </Row>
    </Container>
      </>
  )
}
